import React from 'react';
import PropTypes from 'prop-types';

const Header = props => {
  const { featuredTitleImage, headline, isFirst, theme } = props;

  if (featuredTitleImage) {
    const headerElement = (
      <div className={theme.imageOnly}>
        <img className={theme.headlineImg} src={featuredTitleImage} alt={headline} />
      </div>
    );
    return isFirst ? <h1>{headerElement}</h1> : headerElement;
  }

  if (headline) {
    return <div className={theme.headline}>{headline}</div>;
  }

  return <div className={theme.emptyHeader} />;
};

export default Header;

Header.defaultProps = {
  featuredTitleImage: null,
  headline: null,
  isFirst: false,
  theme: {},
};

Header.propTypes = {
  featuredTitleImage: PropTypes.string,
  headline: PropTypes.string,
  isFirst: PropTypes.bool,
  theme: PropTypes.shape({}),
};
